import MobileObjects from './MobileObjects';

export default MobileObjects;
